module.exports = __webpack_public_path__ + "img/step1.1e2d8a47.png";